module.exports = __webpack_public_path__ + "static/media/DZW_01.77357b2a.jpg";